import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-error-url',
  templateUrl: './error-url.component.html',
  styleUrls: ['./error-url.component.css']
})

export class ErrorUrlComponent implements OnInit {

  error: string|any;

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params:any )=> {
          this.error = params ? params.error : "invalid";
    });
  }

}
